export default {
  namespaced: true,
  state: () => ({
    hasUnsavedChanges: false,
  }),
  mutations: {
    SET_HAS_UNSAVED_CHANGES(state, v) {
      state.hasUnsavedChanges = !!v;
    },
  },
  getters: {
    HAS_UNSAVED_CHANGES: (s) => s.hasUnsavedChanges,
  },
};
